import { Trans } from "@lingui/macro";
import { useMediaQuery, useTheme } from "@mui/material";
import { UiTypography } from "@smp/ui";
import { FC, useMemo, useState } from "react";

import { useEpBillingAccount } from "@/hooks/use_ep_billing_account";
import { useMePermissions } from "@/hooks/use_me_permissions";
import { HeaderButton } from "@/screens/_layout/components/header/shared";
import { DialogTokenPackage } from "@/screens/app/components/dialogs/dialog_token_package";

import classes from "./controls_tokens.module.css";

export const ControlsTokens: FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const permissions = useMePermissions();

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const { accountList } = useEpBillingAccount();

  const balance = useMemo(
    () => accountList?.find((acc) => acc.commodity === "TOKEN")?.balance || 0,
    [accountList],
  );

  if (isMobile || !permissions.tokens_purchase) {
    return null;
  }

  return (
    <>
      <HeaderButton
        className={classes.btn}
        onClick={() => setIsDialogOpen(true)}
        textLeft={<Trans>Credits for X</Trans>}
        textRight={<UiTypography>{balance.toLocaleString()}</UiTypography>}
      />

      <DialogTokenPackage
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
      />
    </>
  );
};
